import { DynamicFieldData } from '@/types/dynamic-control-types';

export const LoginFields: DynamicFieldData[] = [
  {
    fieldName: 'email_or_phone',
    inputType: 'text',
    label: 'Email or Phone Number',
    defaultValue: '',
  },
  {
    fieldName: 'password',
    inputType: 'password',
    label: 'Password',
    defaultValue: '',
  },

  //   {
  //     fieldName: 'language',
  //     inputType: 'select',
  //     label: 'Language',
  //     options: [
  //       { value: 'english', label: 'English' },
  //       { value: 'french', label: 'French' },
  //     ],
  //     defaultValue: 'english',
  //   },
];
